// src/utils/eventBus.ts
import mitt from 'mitt'

// 定义事件类型（可选，但推荐）
type Events = {
    refreshBookList: void
    loginSuccess: { userId: string }
    changeTheme: string
}

const emitter = mitt<Events>()

export default emitter
